import { Subject } from "rxjs";

export class VisibilityService {
  pageVisible$ = new Subject<void>();

  constructor() {
    document.addEventListener("visibilitychange", () => {
      if (!document.hidden) {
        this.pageVisible$.next();
      }
    });
  }
}
